import React, { FC } from 'react';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import cx from 'classnames';
// eslint-disable-next-line no-restricted-imports
import CodeBlockHighlighted from 'plaid-threads/CodeBlockHighlighted';
import { Language } from 'prism-react-renderer';
import styles from './CodeSnippet.module.scss';
import { Section } from 'src/components-v2/Layout';

interface CodeSnippetComponentProps {
  syntax: Language | 'ruby' | 'java';
  children: string;
  className?: string;
  title?: string;
  noBottomMargin?: boolean;
  theme?: 'homepage';
  entryId?: string;
}

const CodeSnippet: FC<CodeSnippetComponentProps> = ({
  className = '',
  syntax,
  children = '',
  title = '',
  noBottomMargin,
  theme = '',
  entryId,
}) => {
  const inspectorProps = useContentfulInspectorMode({ entryId });
  return (
    <Section
      component='figure'
      {...(entryId ? inspectorProps({ fieldId: 'body' }) : null)}
    >
      <CodeBlockHighlighted
        {...{ title }}
        className={cx(styles.overrides, className, {
          [styles.marginBottom]: !noBottomMargin,
          [styles[theme]]: !!theme,
        })}
        code={children}
        lang={syntax}
      />
    </Section>
  );
};

export default CodeSnippet;
